import type { Entity } from '@backstage/catalog-model';
import type { ComponentType, PropsWithChildren, ReactElement } from 'react';

import type { Icon } from './Icon';

export type RouteWithSingleTab = {
  group?: string;
  icon?: Icon;
  title: string;
};

export type RouteWithSubPath = RouteWithSingleTab & {
  subPath: string;
};

export const isRouteWithSubPath = (
  tab: RouteWithSingleTab | RouteWithSubPath,
): tab is RouteWithSubPath => 'subPath' in tab;

type RouteWithMultipleTabs = {
  tabs: RouteWithSubPath[];
};

export const isRouteWithMultipleTabs = (
  props: RouteWithMultipleTabs | RouteWithSingleTab | undefined,
): props is RouteWithMultipleTabs => !!props && 'tabs' in props;

export type DynamicSubRoute = SubRoute & {
  toolbarElements?: ComponentType<{ entity: Entity }>;
  wrapperComponent?: ComponentType<PropsWithChildren<{ entity: Entity }>>;
};

export type SubRoute = (RouteWithMultipleTabs | RouteWithSingleTab) & {
  children: ReactElement;
  path: string;
};

export const hasToolbar = (
  subRoute: SubRoute,
): subRoute is DynamicSubRoute & {
  toolbarElements: ComponentType<{ entity: Entity }>;
} => 'toolbarElements' in subRoute && !!subRoute.toolbarElements;

export const hasWrapper = (
  subRoute: SubRoute,
): subRoute is DynamicSubRoute & {
  wrapperComponent: ComponentType<PropsWithChildren<{ entity: Entity }>>;
} => 'wrapperComponent' in subRoute && !!subRoute.wrapperComponent;
